// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 282 ? "space-materials" : chunkId) + "." + {"282":"200c56e3","453":"3477264b","511":"aebafd68","631":"bc018437","838":"bee10bbb","839":"f01e0e72"}[chunkId] + ".chunk.js";
};